"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  code: {
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default',
      '& $btn': {
        cursor: 'default'
      }
    }
  },
  label: {
    marginBottom: 8,
    display: 'block'
  },
  source: {
    padding: 24,
    margin: 0,
    background: theme.code.backgroundColor,
    borderRadius: theme.code.borderRadius,
    wordBreak: 'break-word',
    overflow: 'hidden'
  },
  pre: {
    background: 'inherit',
    margin: '0 0 4px 0',
    paddingBottom: 20,
    overflowX: 'auto'
  },
  value: {
    color: theme.code.textColor,
    fontSize: theme.code.textSize
  },
  btn: {
    float: 'right'
  }
});
exports.default = _default;